// extracted by mini-css-extract-plugin
module.exports = {"entity-sample":"entity-sample___EZEX-"};